<template>
    <div class="part-intro-header__container">
        <div class="part-intro-header d-flex justify-content-between">
            <div class="part-intro-header__content d-flex align-items-center pl-3">
                <div>
                    <div class="part-intro-header__header-h">
                        <span v-html="part"></span>
                    </div>
                </div>
            </div>
            <div>
                <indicator-ball class="part-intro-header__indicator-ball shaded-fill-white" :variant="variant">
                    <simple-svg
                        :src="icon"
                        class="mt-2 mr-2"
                        width="48px"
                        height="48px"
                    />
                </indicator-ball>
            </div>
        </div>
    </div>
</template>
<script>
import indicatorBall from '@/components/ui/indicatorBall'
export default {
    name: 'partIntroHeader',
    components: {
        'indicator-ball': indicatorBall
    },
    props: {
        part: {
            type: String
        },
        title: {
            type: String
        },
        icon: {
            type: String
        },
        variant: {
            type: String
        }
    },

}
</script>
<style lang="scss">
.part-intro-header {
    height: 80px;
    border-bottom: 0.5px solid $base_grey-2;
}

.part-intro-header__content {
    height: 80px;
}

.part-intro-header__indicator-ball {
    position: relative;
    right: -32px;
    top: -25px;
}

.part-intro-header__header-h {
    font-size: 1.125rem;
}
</style>